<div class="space-between employee-header p-2" *ngIf="!!selectedEntityKyc">
  <div class="space-between">
    <button type="button" mat-icon-button title="Go Back to the Entity" (click)="back()">
      <mat-icon>west</mat-icon>
    </button>
    <span style="display: flex; flex-direction: column; margin-left: 5px">
      <span>{{selectedEntityKyc.kycName}}</span>
      <em class="text-muted" style="font-size: smaller">
        {{ lookupService.getLookupValueForKey(lookupService.lookups.kycRondeivuStatus,  selectedEntityKyc.kycRondeivuStatus)}}
        <span *ngIf="selectedEntityKyc.archived" title="When a KYC is archived, it can no longer be edited"> - ARCHIVED</span>
      </em>
    </span>
  </div>
  <div>
    <form [formGroup]="form">
      <button mat-icon-button [matMenuTriggerFor]="menuhelp" style="margin-right: 15px;" title="Help with this KYC Form">
        <mat-icon color="primary" style="font-size: 26px">support_agent</mat-icon>
      </button>
      <mat-menu #menuhelp>
        <div style="display: flex; flex-direction: column; padding: 15px 20px; gap: 15px">
          <div style="display: flex; flex-direction: column; gap: 15px;">
            <b style="font-size: larger;">Need help with this form?</b>
            <p>
              We understand that the KYC process is a complicated one. If you need help filling this out or are encountering errors, please don't hesitate to contact us.
            </p>
          </div>
          <div style="display: flex; justify-content: start; align-items: center; gap: 5px; gap: 15px;">
            <div class="image">
              <span style="display: block; height: 114px; width: 114px; border-radius: 50%; border: thick solid #0047AB">
                <img style="width: 104px; height: 104px; padding: 5px; border-radius: 50%" src="../../../../../assets/images/steve-photo.jpg" alt="Steve Quintero - Rondeivu Legal">
              </span>
            </div>
            <div class="text" style="display: flex; flex-direction: column; gap: 5px">
              <b style="font-size: larger;">Steve Quintero</b>
              <span><b>Tel:</b> +1-646-759-1882 </span>
              <span><b>Email:</b> legal&#64;rondeivu.com</span>
            </div>
          </div>
        </div>
      </mat-menu>

      <button type="button" mat-raised-button color="primary" (click)="togglePdfView()">
        <mat-icon>{{ viewingPDF ? 'edit' : 'picture_as_pdf' }}</mat-icon>&nbsp;{{ viewingPDF ? 'Back to Editing Current KYC' : 'View PDF of Current KYC' }}
      </button>
      
      &nbsp;
      <button mat-raised-button color="primary" *ngIf="util.isAdmin()" (click)="downloadAdminKYCPackage(selectedEntityKyc.id)">
        Download KYC Package
      </button>
    </form>
  </div>
</div>

<div *ngIf="!viewingPDF">
  <router-outlet></router-outlet>
</div>
<div *ngIf="viewingPDF">
  <ngx-extended-pdf-viewer
    [src]="base64"
    [useBrowserLocale]="true"
    [textLayer]="true"
    [showHandToolButton]="true"
    [showPresentationModeButton]="false"
    [showDownloadButton]="true"
    [showPrintButton]="true"
    [showOpenFileButton]="false"
    [showPropertiesButton]="false"
    [showSidebarButton]="false"
    backgroundColor="#333333"
  ></ngx-extended-pdf-viewer>
</div>
